// extracted by mini-css-extract-plugin
module.exports = {"dimmer":"Modal_dimmer__HE7L2","modal":"Modal_modal__flhoD","inner":"Modal_inner__2mOcf","actions":"Modal_actions__12m3m","closeButton":"Modal_closeButton__287_g"};